<template>
  <div>
    <!--    <div class="zhengzao" v-show="dialogFormVisible" @click="$emit('cancleFeedback')"></div>-->
    <div class="zhengzao" v-show="dialogFormVisible"></div>
    <div v-show="dialogFormVisible" class="containDiv">
      <div class="title">{{$t('feedback.Feedback')}}</div>
      <span class="iconfont el-icon-control-cleanup icon" @click="$emit('cancleFeedback')" ></span>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
        <el-form-item label="" prop="email">
          <el-input v-model="ruleForm.email" :placeholder="$t('feedback.email')"></el-input>
        </el-form-item>
        <el-form-item label="" prop="content" style="height:180px">
          <el-input v-model="ruleForm.content" type="textarea" rows="7" maxlength="300" show-word-limit style="overflow: auto" resize="none" :placeholder="$t('feedback.content')"></el-input>
        </el-form-item>
        <el-button type="primary" class="button" @click="submitForm('ruleForm')">{{$t('feedback.submit')}}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import {validateEmail} from "@/utils/validate";
import {insertFeedback} from '@/api/feedBack'
export default {
  name: 'FeedBack',
  props: {
    dialogFormVisible: false
  },
  data() {
    return {
      ruleForm: {
        email: '',
        content:""
      },
      rules: {
        email: [
          { required: true,
            message: this.$t('feedback.emailNoEmpty'),
            trigger: '' },
          { min: 5, max: 100, message: this.$t('feedback.emailLength'), trigger: 'blur' },
          {
            required: true,
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: this.$t('feedback.emailNoChinese'),
            trigger: 'blur'
          },
          {
            required: true,
            pattern: /^[^\~!#$%^&*()_￥·`！。……（）——=|》《？+<>?:"{},\/;'[\]]{0,}$/,
            message: this.$t('feedback.emailSpecialString'),
            trigger: 'blur'
          },

          {
            validator: (rule, value, callback) => {
              if (validateEmail(value)) {
                callback();
              }
              callback(new Error(this.$t('feedback.emailTrueRule')));
            },
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: this.$t('feedback.contentNoEmpty'), trigger: '' },
        ]
      }
    };

  },
  methods:{
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    /*obtainFbPath(){
      let _this = this;
      let fbPath = _this.$route.path;
      let pathName = _this.$route.meta.title;
      let fb = {};
      fb.path = fbPath;
      fb.name = pathName;
      return JSON.stringify(fb);
    },*/
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          let parm = new Object();
          let parm1 = new Object();
          parm1.fbEmail = _this.ruleForm.email
          parm1.fbInfo = _this.ruleForm.content;
          parm1.fbPath = _this.$route.meta.chineseName;
          parm1.fbDomain = window.location.protocol+'//'+window.location.host;
          parm1.type = 1;
          parm.jsonBody = parm1;
          return new Promise((resolve, reject) => {
            insertFeedback(parm).then(res =>{
              debugger
                let jsonBodyData = res.jsonBody;
                let rtnCode = jsonBodyData.rtnCode;
                if(rtnCode === 0){
                  _this.$message({
                    message:this.$t('feedback.feedbackSuccess'),
                    type:'success'
                  })
                  _this.$emit('cancleFeedback')
                  /*this.$eventBus.$emit('isFeedBack')*/
                }else{
                  _this.$message({
                    message:this.$t('feedback.feedbackFailed'),
                    type:'error'
                  })
                }

              }
            ).catch(()=>{
              debugger
                _this.$message({
                  message:this.$t('feedback.feedbackFailed'),
                  type:'error'
                })
              }

            )

          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.button{
  position: absolute;
  right: 20px;
  bottom: 20px
}
.demo-ruleForm{
  margin-top: 36px;
  padding: 0 20px;
}
.icon{
  position: absolute;
  top: 20px;
  right: 20px;
}
.zhengzao{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  opacity: 1;
  background: rgba(0,0,0,0.50);
  z-index: 1990;
}
.containDiv{
  width: 452px;
  height: 380px;
  opacity: 1;
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.25);
  position: fixed;
  z-index: 2000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.title{
  height: 16px;
  opacity: 1;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #000000;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 20px
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/FeedBack.vue